import { Controller } from 'stimulus';
import LocomotiveScroll from 'locomotive-scroll';
import gsap from 'gsap';
import getControllerForElement from '../helpers/getControllerForElement';
import toArray from '../helpers/toArray';

class LocomotiveScrollController extends Controller {
  connect() {
    this.scroll = new LocomotiveScroll({
      el: this.element,
    });

    this.scroll.on('scroll', (event) => {
      const { currentElements, scroll } = event;

      if (typeof currentElements !== 'undefined' && Object.keys(currentElements).length) {
        const currentElementsArr = Object.keys(currentElements).map((key) => currentElements[key]);

        this.handleCurrentElementsScroll(currentElementsArr, scroll);
      }
    });

    this.scroll.on('call', (funcName, state, locomotiveObj) => {
      if (funcName === 'video') {
        this.handleVideoCall(state, locomotiveObj);
      }

      if (funcName === 'fade') {
        this.handleFade(state, locomotiveObj);
      }

      if (funcName === 'fade-children') {
        this.handleFadeChildren(state, locomotiveObj);
      }
    });
  }

  /* eslint-disable-next-line class-methods-use-this */
  handleCurrentElementsScroll(currentElements, scroll) {
    const heroElementsInView = currentElements.filter((currentElement) => currentElement.el.getAttribute('data-hero-bg') === '');

    if (heroElementsInView.length) {
      this.handleHeroElementsScroll(heroElementsInView, scroll.y);
    }
  }

  // eslint-disable-next-line class-methods-use-this
  handleHeroElementsScroll(elements, scrollY) {
    elements.forEach((element) => {
      const { el, top, bottom } = element;

      // Scroll position inside the element. So if the element is at 200px on the page and
      // the user is scrolled 300px. This will return 100px.
      const inElementY = scrollY - top;

      const elementHeight = bottom - top;

      // If the scroll is not passed the top border of the element.
      if (inElementY < 0) {
        return;
      }

      const progress = inElementY / elementHeight;

      gsap.to(el, {
        scale: 1 + (progress * 0.2),
      });
    });
  }

  handleVideoCall(state, locomotiveObj) {
    // Retrieve the Stimulus controller for the element
    getControllerForElement(this.application, locomotiveObj.el, 'video').then((controller) => {
      // Call the function that handles autoplay on the video controller.
      controller.onWindowScroll(state === 'enter');
    });
  }

  // eslint-disable-next-line class-methods-use-this
  handleFade(state, locomotiveObj) {
    gsap.fromTo(locomotiveObj.el, {
      y: '20px',
      opacity: 0,
    }, {
      y: 0,
      opacity: 1,
      duration: 1,
      delay: 0.25,
    });
  }

  // eslint-disable-next-line class-methods-use-this
  handleFadeChildren(state, locomotiveObj) {
    const children = toArray(locomotiveObj.el.querySelectorAll('[data-fade-child]'));

    gsap.fromTo(locomotiveObj.el, {
      opacity: 0,
    }, {
      opacity: 1,
      duration: 1,
    });

    gsap.fromTo(children, {
      y: '20px',
      opacity: 0,
    }, {
      y: 0,
      opacity: 1,
      duration: 1,
      delay: 0.5,
      stagger: 0.25,
    });
  }
}

LocomotiveScrollController.targets = [
  //
];

export default LocomotiveScrollController;
